'use strict';

class AvatarData {
    constructor() {
        this.avatarMeshArray = [];
        this.avatarMeshArrayBoundingBox = new THREE.Box3();

        this.headGroupName = "Head Group";
        this.headName = "Head";
        this.avatarTooltip = "avatarTooltip";

        this.avatarTooltipPosition = new THREE.Vector3(0, 0.24, 0);
    }
}

export default AvatarData;
